define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/reflection",
	"csi/tabs/Content"
], function(declare, lang, reflection, Content) {

	return declare(Content, {
		// Class: class of node from which tab (page) is created - only used in wizard views to find views if not in actual node context
		//rcContext: null,

		// Boolean: wizards need to force query for each page since cannot query for all pages at beginning
		_bForceRootNode: true,

		// Boolean: all views need to be accessed in wizard
		_bTestViewAccess: false,

		createView: function(/*csi.wizard.Widget*/wizard, /*Boolean*/bRefresh) {
			// summary: create wizard page view
			var view = this.getView(wizard);
			var bStarted = view && view.isStarted();

			bRefresh = bRefresh || !bStarted;

			if (view && bRefresh) {
				// reset query for view if view is first being created or refreshed
				var index = wizard.getIndexOfPage(this);
				var ac = wizard.getSourceController();
				var q = ac.getWizardViewQuery(wizard, view, index);
				if (q) {
					view.relRoot.addQuery(q, true);
				}

				view.placeAt(this.domNode);

				return bStarted ? view.refreshWidget() : view.startup();
			} else if (view) {
				// call to refreshTab will disable the toolbar if already created, so need to reenable here
				view.reenableToolbar();
			}

			return null;
		},

		getNode: function(/*csi.wizard.Widget*/wizard, /*String*/url) {
			// summary: get node from page's cache
			return this.getView(wizard).cacheView.getNode(url);
		},

		getPageData: function() {
			// summary: get form data for view
			return this.viewTab ? this.viewTab.defView.m_formData : null;
		},

		getView: function(/*csi.wizard.Widget*/wizard, /*Object?*/params) {
			// summary: create and return view for tab if visible
			if (!this.viewTab) {
				var ac = wizard.getSourceController();
				var rootNode = wizard.cacheView.get(this.urlRootNode);
				var defView = this._getViewDef(rootNode);
				if (defView) {
					// remove any actions associated with view - wizard view displays the actions instead
					defView.m_defActions = null;

					// notify action controller of view definition
					params = params || {};
					ac.onWizardViewPreCreate(wizard, this, defView, params);

					// if no root node, then use wizard root node as default... unless view specifically targets another class
					// FIX: this.urlRootNode should ideally handle this case, but too many wizard variations now to make the change;
					// refreshTab could be changed to handle it, but sometimes this function is called explicitly rather than through setFormDataToPage
					if (!rootNode && !this.defTab.target) {
						rootNode = wizard.getViewNode();
					}

					// create and insert view, and then notify controller
					if (this.viewTab = wizard._insertView(defView, rootNode, params, true)) {
						ac.onWizardViewCreate(wizard, this, this.viewTab);
					}
				} else {
					this.viewTab = null;
				}
			} else if (params) {
				if (params.formData) {
					this.viewTab.defView.setFormData(params.formData);
					delete params.formData;
				}
				lang.mixin(this.viewTab, params);
			}

			return this.viewTab;
		},

		refreshTab: function(/*Context*/ctx) {
			// summary: setup class context for page to aid in finding its view
			// FIX: Can we use ViewRef/@Target property instead?
			this.rcContext = reflection.getClass(ctx.defView && ctx.defView.getTypeNode());
			this.inherited(arguments);
		},

		_getRootClass: function() {
			// summary: use class context as starting point to find root class for tab view
			return this.defTab.getRootNodeClass(this.rcContext);
		}
	});
});